module.exports = __webpack_public_path__ + "static/img/business_chair_h4_l.b1fc435.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/business_chair_h4_l.png
// module id = QziV
// module chunks = 3